import { PageData, PageDataParams } from './page-data';
import {
  Skill,
  PageType,
  RawPageData,
  RawModuleCompletionPageData,
} from '../common/page-data';

export class ModuleCompletionData extends PageData {
  private _currentSkill: Skill;
  private _competencyText: string;

  public get pageType(): PageType {
    return PageType.Banner;
  }

  public get currentSkill(): Skill {
    return this._currentSkill;
  }

  public get competencyText(): string {
    return this._competencyText;
  }
  public get rawData(): RawPageData {
    const playStats = this.playStats;

    playStats.progress = 100;
    const raw: RawPageData = {
      ...this._rawPageData,
      playStats,
    };

    return raw;
  }

  public constructor(params: PageDataParams) {
    super(params);

    const { rawPageData } = params;

    this._currentSkill = rawPageData.skill;

    this._competencyText =
      (rawPageData as RawModuleCompletionPageData)?.data?.markdown || '';
  }
}
